module.exports = __webpack_public_path__ + "static/media/digital_design.4d1fa95e.png";